// Файл reportWebVitals.js

/**
 * Модуль обслуживает сценарий `reportWebVitals` в разделе `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

// Сбор информации о производительности приложения
const reportWebVitals = onPerfEntry => {
    if (onPerfEntry 
    && onPerfEntry instanceof Function) {
        import('web-vitals')
        .then(({ 
            getCLS, 
            getFID, 
            getFCP, 
            getLCP, 
            getTTFB }) => {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);});
    }
};


export default reportWebVitals;
